const defaultState = {
  roomObj: {},
  sessionObj: {},
  sliceGameCode: "",
  gameName: "",
  branchJoincode: "",
  currentUser: {},
  show_leave_game: false,
  bingo_board: [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 1, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0]
  ],
  gah_new_card: {
    active: false,
    card: {}
  },
  header_drop_down: false,
  drop_down_help: false,
  set_ready_to_vote: false,
  dw20_new_card: {
    active: false,
    card: {}
  },
  chpt_new_card: {
    active: false,
    card: {}
  },
  ct_selected_player: null,
  ct_selected_card: "",
  ct_steal_button: false,
  ct_dice_special6: false,chpt_result_modal:false, och_new_card: {},
};

const setRoomDetails = (state, action) => {
  const roomObj = action.data.data || action.data.room;
  return roomObj;
};
const gameReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_ROOM": {
      const roomDetails = setRoomDetails(state, action);
      let newState = {
        ...state,
        roomObj: roomDetails
      };
      if (action.data.gameTiming) {
        return { ...newState, ...action.data.gameTiming };
      } else return newState;
    }
    case "SET_SESSION": {
      return {
        ...state,
        sessionObj: action.data
      };
    }
    case "SET_BRANCH_JOIN_CODE": {
      return {
        ...state,
        branchJoincode: action.data
      };
    }

    case "SET_SLICE_GAME_CODE": {
      return {
        ...state,
        sliceGameCode: action.data
      };
    }
    case "SET_CURRENT_USER": {
      return {
        ...state,
        currentUser: action.data
      };
    }
    case "END_GAME": {
      return {
        ...state,
        roomObj: {},
        gameName: ""
      };
    }
    case "SET_GAME_NAME": {
      return {
        ...state,
        gameName: action.data
      };
    }
    case "SET_MOBILE_APP": {
      return {
        ...state,
        mobile_app: action.data
      };
    }
    case "HOW_TO_PLAY": {
      return {
        ...state,
        how_to_play: action.data
      };
    }
    case "SHOW_LEAVE_GAME": {
      return {
        ...state,
        show_leave_game: action.data
      };
    }
    case "SET_BINGO_BOARD": {
      return {
        ...state,
        bingo_board: action.data
      };
    }

    case "SET_HEADER_DROP_DOWN": {
      return {
        ...state,
        header_drop_down: action.data
      };
    }
    case "SET_GAH_NEW_CARD": {
      return {
        ...state,
        gah_new_card: action.data
      };
    }
    case "SET_CHPT_NEW_CARD": {
      return {
        ...state,
        chpt_new_card: action.data
      };
    }
    case "SET_DROP_DOWN_HELP": {
      return {
        ...state,
        drop_down_help: action.data
      };
    }

    case "SET_READY_TO_VOTE": {
      return {
        ...state,
        ready_to_vote: action.data
      };
    }
    case "SET_DW20_NEW_CARD": {
      return {
        ...state,
        dw20_new_card: action.data
      };
    }
    case "SET_CT_SELECTED_PLAYER": {
      return {
        ...state,
        ct_selected_player: action.data
      };
    }
    case "SET_CT_SELECTED_CARD": {
      return {
        ...state,
        ct_selected_card: action.data
      };
    }
    case "SET_CT_STEAL_BUTTON": {
      return {
        ...state,
        ct_steal_button: action.data
      };
    }
   case "SET_CT_DICE_SPECIAL6": {
      return {
        ...state,
        ct_dice_special6: action.data
      };
    } 
    case "SET_CHPT_RESULT_MODAL": {
      return {
        ...state,
        chpt_result_modal: action.data
      };
    } 
    case "SET_OCH_NEW_CARD": {
      return {
        ...state,
        och_new_card: action.data
      };
    }
   
    default:
      return state;
  }
};

export default gameReducer;
